import { Route } from 'common/types/tech';
import React from 'react';

const VerifyInvitation = React.lazy(() => import('modules/common/verify-invitation'));

export const getCommonRoutes = (): Array<Route> => [
  {
    path: '/invitation',
    preview: 'Verify Invitation',
    component: VerifyInvitation,
    checkAvailability: () => true,
    protected: false,
  },
];
